import {
  Stack,
  TextField,
  useTheme,
  Button,
  Container,
  Typography,
  Paper,
  Grid,
  Dialog,
  TableContainer,
  Table,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
  TablePagination,
  IconButton,
  DialogTitle,
  DialogActions,
  Snackbar,
  Alert,
  Autocomplete,
  LinearProgress,
  FormControl,
  FormLabel,
  RadioGroup,
  FormControlLabel,
  Radio,
  Chip,
} from '@mui/material';
import Slide from '@mui/material/Slide';
import CheckCircleOutlineIcon from '@mui/icons-material/CheckCircleOutline';
import HighlightOffIcon from '@mui/icons-material/HighlightOff';
import CloseIcon from '@mui/icons-material/Close';
import React, { useEffect, useState } from 'react';
import useMediaQuery from '@mui/material/useMediaQuery';
import styled from '@emotion/styled';
import EditIcon from '@mui/icons-material/Edit';
import DeleteForeverIcon from '@mui/icons-material/DeleteForever';
import PlaylistAddIcon from '@mui/icons-material/PlaylistAdd';
import AddLocationAltRoundedIcon from '@mui/icons-material/AddLocationAltRounded';
import axios from '../../axiosConfig';
import './animation.css';

// table header cell styles
const StyledTableCell = styled(TableCell)({
  color: '#424242',
  fontWeight: '600',
  // textAlign: 'center',
});

const MachineMst = () => {
  const [tokent, settokent] = useState(
    'Bearer eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJldmVudGxpc3QiOlt7IlVzZXJJRCI6IjEiLCJMb2dpbkNvZGUiOiIwMSIsIkxvZ2luTmFtZSI6IkFkbWluIiwiRW1haWxJZCI6ImFkbWluQGdtYWlsLmNvbSIsIlVzZXJUeXBlIjoiQURNSU4ifV0sImlhdCI6MTYzODM1NDczMX0.ZW6zEHIXTxfT-QWEzS6-GuY7bRupf2Jc_tp4fXIRabQ'
  );
  const theme = useTheme();
  const fullScreen = useMediaQuery(theme.breakpoints.down('xs'));
  const [open, setOpen] = useState(false);
  const [isFormSubmitted, setIsFormSubmitted] = useState(false);
  const [openAlert, setopenAlert] = useState(false);
  const [openDelete, setOpenDelete] = useState(false);
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [searchTerm, setSearchTerm] = useState('');
  const [operation, setOperation] = useState('Add');
  // alert messages on operations
  const [alertType, setAlertType] = useState('success'); // 'success' or 'error'
  const [alertMessage, setAlertMessage] = useState('');

  const [errors, setErrors] = useState({
    MachineType: false,
    shortCode: false,
    MachineName: false,
    StitchperInch: false,
    RMP: false,
    Active: false,
  });

  const [helperTexts, setHelperTexts] = useState({
    MachineType: '',
    shortCode: '',
    MachineName: '',
    StitchperInch: '',
    threadinch: '',
    threadConsumptionFactor: '',
    RMP: '',
    Active: '',
  });
  const [Active, setActive] = useState('Y');

  // input fields state values
  const [MachineType, setMachineType] = useState('');
  const [Shortcode, setShortcode] = useState('');
  const [MachineName, setMachineName] = useState('');
  const [StitchperInch, setStitchperInch] = useState('');
  const [RMP, setRMP] = useState('');
  const [Inch, setInch] = useState('');
  const [tcf, settcf] = useState('')

  const [MachineData, setMachineData] = useState([]);
  // const [selectedCountry, setSelectedCountry] = useState(null);
  const [editID, setEditID] = useState();
  const [IdToDelete, setIdToDelete] = useState(null);

  const [openLoader, setOpenLoader] = useState(false);

  // API Integration
  useEffect(() => {
    GetAllMachine();
    // getCountries();
  }, []);

  // get all Cities Request
  // const getCountries = async () => {
  //   setOpenLoader(true);
  //   try {
  //     const res = await axios.instance.get('/GetAllCountry', {
  //       headers: { Authorization: tokent, 'Content-Type': 'application/json' },
  //     });
  //     setCountryData(res.data);
  //     setOpenLoader(false);
  //   } catch (error) {
  //     console.error('Error fetching data:', error);
  //   }
  // };

  // get all Users Request
  const GetAllMachine = async () => {
    setOpenLoader(true);
    try {
      const res = await axios.instance.get('/GetAllMachineMstData', {
        headers: { Authorization: tokent, 'Content-Type': 'application/json' },
      });
      setMachineData(res.data);
      setOpenLoader(false);
    } catch (error) {
      console.error('Error fetching courses:', error);
    }
  };

  // post Request to Add new record
  const insertBuyers = async (newData) => {
    try {
      const res = await axios.instance.post('/InsertMachineMstData', newData, {
        headers: { Authorization: tokent, 'Content-Type': 'application/json' },
      });
      GetAllMachine();
      setAlertType('success');
      setAlertMessage(operation === 'Edit' ? ' updated Successfully!' : ' Added Successfully!');
      setopenAlert(true);
    } catch (error) {
      console.error('Error adding User:', error);
      setAlertType('error');
      setAlertMessage(operation === 'Edit' ? 'Failed to Update the Machine!' : 'Failed to add the Machine!');
      setopenAlert(true);
    }
  };

  // put Request to edit record
  const EditBuyer = async (userId, updatedUser) => {
    try {
      await axios.instance.put(`/EditBuyers/${userId}`, updatedUser, {
        headers: { Authorization: tokent, 'Content-Type': 'application/json' },
      });
      setopenAlert(true);
      setEditID();
      GetAllMachine();
      setAlertType('success');
      setAlertMessage('User Updated Successfully!');
    } catch (error) {
      console.error('Error updating User:', error);
      setAlertType('error');
      setAlertMessage('Failed to update the User.');
      setopenAlert(true);
    }
  };

  // delete Request to delete record
  const deleteBuyer = async (DelId) => {
    try {
      await axios.instance
        .delete(`/DeleteMachineMstData/${DelId}`, {
          headers: { Authorization: tokent, 'Content-Type': 'application/json' },
        })
        .then((res) => {
          if (res.data === '') {
            GetAllMachine();
            setOpenDelete(false);
            setAlertType('warning');
            setAlertMessage('Machine Data Deleted Successfully!');
            setopenAlert(true);
          } else {
            GetAllMachine();
            setOpenDelete(false);
            setAlertType('error');
            setAlertMessage("Oops! Can't delete this data. It's connected to other information.");
            setopenAlert(true);
          }
          console.log(res.data);
        });
    } catch (error) {
      console.error('Error deleting Buyer:', error);
      setAlertType('error');
      setAlertMessage('Failed to delete the Machine Data.');
      setopenAlert(true);
    }
  };

  const resetFields = () => {
    setMachineType('');
    setShortcode('');
    setMachineName('');
    setStitchperInch('');
    setRMP('');
    setInch('');
    settcf('');
    // setActive('');
    errors.MachineType = false;
    errors.shortCode = false;
    errors.MachineName = false;
    errors.StitchperInch = false;
    errors.RMP = false;
    errors.Active = false;
    helperTexts.MachineType = '';
    helperTexts.shortCode = '';
    helperTexts.MachineName = '';
    helperTexts.StitchperInch = '';
    helperTexts.RMP = '';
    helperTexts.Active = '';
    helperTexts.threadinch = '';
    helperTexts.threadConsumptionFactor = '';
    // setSelectedCountry(null);
    // setContactperson('');
  };

  // submit button on add or edit
  const handleSubmit = (event) => {
    event.preventDefault();

    const inputValidation =
      errors.MachineType ||
      // errors.shortCode ||
      errors.MachineName ||
      // errors.StitchperInch ||
      // errors.RMP ||
      errors.Active ||
      !MachineType ||
      // !Shortcode ||
      !MachineName ||
      // !StitchperInch ||
      // !RMP ||
      !Active;

    if (inputValidation) {
      if (!MachineType) {
        setErrors((prevErrors) => ({ ...prevErrors, MachineType: true }));
        setHelperTexts((prevHelperTexts) => ({
          ...prevHelperTexts,
          MachineType: 'Please Enter Machine Type',
        }));
      }
      // if (!Shortcode) {
      //   setErrors((prevErrors) => ({ ...prevErrors, shortCode: true }));
      //   setHelperTexts((prevHelperTexts) => ({
      //     ...prevHelperTexts,
      //     shortCode: 'Please Enter Short code',
      //   }));
      // }
      if (!MachineName) {
        setErrors((prevErrors) => ({ ...prevErrors, MachineName: true }));
        setHelperTexts((prevHelperTexts) => ({
          ...prevHelperTexts,
          MachineName: 'Please Select Machine Name',
        }));
      }
      // if (!StitchperInch) {
      //   setErrors((prevErrors) => ({ ...prevErrors, StitchperInch: true }));
      //   setHelperTexts((prevHelperTexts) => ({
      //     ...prevHelperTexts,
      //     StitchperInch: 'Please Enter Stitch Per Inch',
      //   }));
      // }
      // if (!RMP) {
      //   setErrors((prevErrors) => ({ ...prevErrors, RMP: true }));
      //   setHelperTexts((prevHelperTexts) => ({
      //     ...prevHelperTexts,
      //     RMP: 'Please Enter RMP',
      //   }));
      // }
      // if (!contactNo) {
      //   setErrors((prevErrors) => ({ ...prevErrors, contactNo: true }));
      //   setHelperTexts((prevHelperTexts) => ({
      //     ...prevHelperTexts,
      //     contactNo: 'Please Enter Phone Number',
      //   }));
      // }
      if (!Active) {
        setErrors((prevErrors) => ({ ...prevErrors, Active: true }));
        setHelperTexts((prevHelperTexts) => ({
          ...prevHelperTexts,
          Active: 'Please select Active Status',
        }));
      }
    }

    if (inputValidation) {
      return;
    }

    setErrors((prevErrors) => ({
      ...prevErrors,
      MachineType: false,
      Shortcode: false,
      MachineName: false,
      StitchperInch: false,
      RMP: false,
      threadinch: false,
      threadConsumptionFactor: false,
      Active: false,
    }));

    setHelperTexts((prevHelperTexts) => ({
      ...prevHelperTexts,
      MachineType: '',
      Shortcode: '',
      MachineName: '',
      StitchperInch: '',
      RMP: '',
      Active: '',
      threadinch: '',
      threadConsumptionFactor: '',
    }));

    const newData = {
      optype: operation === 'Edit' ? 'Edit' : 'Add',
      Machine_Id: operation === 'Edit' ? editID : '',
      MachineType,
      Short_code: Shortcode,
      Machine_name: MachineName,
      Stitch_per_Inch: StitchperInch === '' ? 0 : StitchperInch,
      RMP: RMP === '' ? 0 : RMP,
      threadinch: '' ? 0 : Inch,
      threadConsumptionFactor: '' ? 0 : tcf,
      Active,
      [operation === 'Edit' ? 'ModifyedBy' : 'CreatedBy']: sessionStorage.getItem('UserID'),
    };
    insertBuyers(newData);

    console.log('submitted', newData);

    console.log('added data', newData);

    // if (operation === 'Add') {
    //   insertBuyers(newData);
    // } else if (operation === 'Edit') {
    //   console.log(editID, newData);
    //   EditBuyer(editID, newData);
    // }
    resetFields();
    handleClose();
  };

  const handleInputChange = (event) => {
    const { name, value } = event.target;
    const numericFields = ['StitchperInch', 'RMP', 'threadinch', 'threadConsumptionFactor'];


    if (numericFields.includes(name) && !/^\d*\.?\d*$/.test(value)) {
      return;
    }


    if (name === 'MachineType') setMachineType(value);
    if (name === 'shortCode') setShortcode(value);
    if (name === 'MachineName') setMachineName(value);
    if (name === 'StitchperInch') setStitchperInch(value);
    if (name === 'RMP') setRMP(value);
    if (name === 'Active') setActive(value);
    if (name === 'threadinch') setInch(value);
    if (name === 'threadConsumptionFactor') settcf(value);
    validateInput(name, value);
  };

  // validations

  const validateInput = (name, value) => {
    let error = false;
    let helperText = '';

    const emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
    const nameRegex = /^[A-Za-z\s]+$/;
    const contactRegex = /^\d{10}$/;

    const passWordRegex = /^(?=.*[A-Z])(?=.*[a-z])(?=.*\d)(?=.*[!@#$%^&*]).*$/;
    // "Password must meet the requirements: at least one uppercase letter,
    // one lowercase letter or number, and one special character (!@#$%^&*)"
    const isDataExists = MachineData.some((data) => data.Machine_name.toLowerCase() === value.toLowerCase().trim());
    const isDataExistsinEdit = MachineData.some(
      (data) => data.Machine_name.toLowerCase() === value.toLowerCase().trim() && data.Machine_Id !== editID
    );

    if (name === 'MachineType') {
      if (!value.trim()) {
        error = true;
        helperText = 'Machine Type field cannot be empty';
        setIsFormSubmitted(false);
      }
    }


    if (name === 'MachineName') {
      if (!value.trim()) {
        error = true;
        helperText = 'Machine Name field cannot be empty';
        setIsFormSubmitted(false);
      } else if (operation === 'Add' && isDataExists) {
        error = true;
        helperText = 'Machine Name already exists';
        setIsFormSubmitted(false);
      } else if (operation === 'Edit' && isDataExistsinEdit) {
        error = true;
        helperText = 'Machine Name already exists';
        setIsFormSubmitted(false);
      } else {
        setIsFormSubmitted(true);
      }
    } else if (name === 'shortCode') {
      if (!value.trim()) {
        error = true;
        helperText = 'Short Code cannot be empty';
        setIsFormSubmitted(false);
      } else {
        setIsFormSubmitted(true);
      }
    }
    // else if (name === 'StitchperInch') {
    //   if (!value.trim()) {
    //     error = true;
    //     helperText = 'Stitch Per Inch field cannot be empty';
    //     setIsFormSubmitted(false);
    //   }
    //   // else if (!emailRegex.test(value)) {
    //   //   error = true;
    //   //   helperText = 'please enter a valid email';
    //   //   setIsFormSubmitted(false);
    //   // }
    //   else {
    //     setIsFormSubmitted(true);
    //   }
    // } else if (name === 'RMP') {
    //   if (!value.trim()) {
    //     error = true;
    //     helperText = 'RMP field cannot be empty';
    //     setIsFormSubmitted(false);
    //   }
    //   //  else if (!contactRegex.test(value) && value.length > 10) {
    //   //   error = true;
    //   //   helperText = 'cannot exceed more than 10 numbers';
    //   //   setIsFormSubmitted(false);
    //   // } else if (value.length < 10) {
    //   //   error = true;
    //   //   helperText = 'enter 10 digit mobile numbers';
    //   //   setIsFormSubmitted(false);
    //   // }
    //   else {
    //     setIsFormSubmitted(true);
    //   }
    // }
    // else if (name === 'UserPassword') {
    //   if (!value.trim()) {
    //     error = true;
    //     helperText = 'User Password field cannot be empty';
    //     setIsFormSubmitted(false);
    //   } else if (!passWordRegex.test(value)) {
    //     error = true;
    //     helperText =
    //       'Password must meet the requirements: at least one uppercase letter, one lowercase letter or number, and one special character (!@#$%^&*), for example; User@123456';
    //     setIsFormSubmitted(false);
    //   } else {
    //     setIsFormSubmitted(true);
    //   }
    // }
    else if (name === 'Active') {
      if (!value.trim()) {
        error = true;
        helperText = 'Plaese select user status';
        setIsFormSubmitted(false);
      } else {
        setIsFormSubmitted(true);
      }
    }

    setErrors((prevErrors) => ({
      ...prevErrors,
      [name]: error,
    }));
    setHelperTexts((prevHelperTexts) => ({
      ...prevHelperTexts,
      [name]: helperText,
    }));
  };

  const handleBlur = (event) => {
    // console.log(event.target.name, event.target.value, event.target,'blur');
    const { name, value } = event.target;
    if (value.length > 0) {
      validateInput(name, value);
    }
  };

  // handle edit popup dialog
  const handleAddOpen = () => {
    setOpen(true);
    setOperation('Add');
  };

  const handleEdit = (datas) => {
    console.log(datas, 'dfdf');
    setInch(datas.threadinch);
    settcf(datas.threadConsumptionFactor);
    setEditID(datas.Machine_Id);
    setMachineType(datas.MachineType);
    setShortcode(datas.Short_code);
    setMachineName(datas.Machine_name);
    setStitchperInch(datas.Stitch_per_Inch);
    setRMP(datas.RMP);
    // const selectedCountryObj = countryData.find((cntry) => parseInt(cntry.id, 10) === parseInt(datas.Country, 10));
    // setSelectedCountry(selectedCountryObj);
    setActive(datas.Active);
    handleEditOpen();
    // console.log(selectedCountryObj, 'edit data', datas);
  };

  const handleEditOpen = () => {
    setOpen(true);
    setOperation('Edit');
  };

  const handleDelete = (idDel) => {
    setOpenDelete(true);
    setIdToDelete(idDel);
  };

  const handleDeleteConfirmed = (idtoDel) => {
    deleteBuyer(idtoDel);
  };

  const handleCloseDelete = () => {
    setOpenDelete(false);
    setopenAlert(false);
  };

  const handleCloseAlert = () => {
    setopenAlert(false);
  };

  const handleClose = () => {
    resetFields();
    setOpen(false);
  };

  // search & filter
  const filteredData = MachineData.filter((enq) => {
    const searchTermLowerCase = searchTerm.toLowerCase();
    return Object.values(enq).some((value) => {
      if (typeof value === 'string') {
        return value.toLowerCase().includes(searchTermLowerCase);
      }
      return false;
    });
  });

  // const handleInputChangeSelect = (event, newValue) => {
  //   setSelectedCountry(newValue);

  //   if (!newValue) {
  //     // Check if the newValue is null or undefined
  //     setErrors((prevErrors) => ({ ...prevErrors, Country: true }));
  //     setHelperTexts((prevHelperTexts) => ({ ...prevHelperTexts, Country: 'Please select a country' }));
  //   } else {
  //     setErrors((prevErrors) => ({ ...prevErrors, Country: false }));
  //     setHelperTexts((prevHelperTexts) => ({ ...prevHelperTexts, Country: '' }));
  //   }
  // };

  // pagination
  const emptyRows = rowsPerPage - Math.min(rowsPerPage, filteredData.length - page * rowsPerPage);
  const totalRows = filteredData.length;
  const totalPages = Math.ceil(totalRows / rowsPerPage);
  const currentPage = Math.max(0, Math.min(page, totalPages - 1)); // Clamp to the range [0, totalPages - 1]
  // Reset page to 0 when searchTerm changes
  useEffect(() => {
    setPage(0);
  }, [searchTerm]);

  return (
    <>
      <Snackbar
        style={{ marginTop: '45px' }}
        open={openAlert}
        autoHideDuration={3000}
        onClose={handleCloseAlert}
        anchorOrigin={{ vertical: 'top', horizontal: 'right' }}
        TransitionComponent={(props) => <Slide {...props} direction={'right'} />}
      >
        <Alert onClose={handleCloseAlert} severity={alertType} variant="filled" sx={{ width: '100%' }}>
          {alertMessage}
        </Alert>
      </Snackbar>

      <Container maxWidth={'xl'} elevation={3}>
        <Grid justifyContent={'space-between'} alignItems={'center'} spacing={2}>
          <Typography
            variant="h5"
            p={1}
            boxShadow={1}
            borderColor="#11235A"
            textAlign={'center'}
            borderRadius={2}
            pl={2}
            color="white"
            sx={{
              background: 'linear-gradient(to right, #314755, #26a0da)',
              boxShadow: 'rgba(60, 64, 67, 0.3) 0px 1px 2px 0px, rgba(60, 64, 67, 0.15) 0px 2px 6px 2px',
            }}
          >
            <Typography variant="h6" color="white" className="font_style1" textAlign={'center'}>
              Machine Master
            </Typography>
          </Typography>
        </Grid>
        {/* search & add button */}
        <Stack direction={'row'} justifyContent={'space-between'} alignItems={'center'} spacing={2} my={2}>
          <TextField
            type="text"
            variant="outlined"
            color="secondary"
            label="Search"
            size="small"
            onChange={(e) => setSearchTerm(e.target.value)}
            value={searchTerm}
          />
          <Button
            variant="outlined"
            color="secondary"
            sx={{ boxShadow: 1 }}
            onClick={handleAddOpen}
            startIcon={<PlaylistAddIcon />}
          >
            Add Machine
          </Button>
        </Stack>

        {/* table  */}
        <TableContainer>
          <Table size="small">
            <TableHead>
              <TableRow>
                <StyledTableCell align="center">S.No</StyledTableCell>
                <StyledTableCell align="left">Machine Type</StyledTableCell>
                <StyledTableCell align="left">Machine Name</StyledTableCell>
                <StyledTableCell align="left">SPI</StyledTableCell>
                <StyledTableCell align="left">RPM</StyledTableCell>
                <StyledTableCell align="left">TPI</StyledTableCell>
                <StyledTableCell align="left">TCF</StyledTableCell>
                <StyledTableCell align="center">Active</StyledTableCell>
                <StyledTableCell align="center">Actions</StyledTableCell>
              </TableRow>
            </TableHead>

            <TableBody>
              {(rowsPerPage > 0
                ? filteredData.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                : filteredData
              ).map((datas, index) => (
                <TableRow key={datas.Machine_Id} hover>
                  <TableCell align="center">{datas.SNo}</TableCell>
                  <TableCell align="left">{datas.MachineType}</TableCell>
                  <TableCell align="left">{datas.Machine_name}</TableCell>
                  <TableCell align="left">{datas.Stitch_per_Inch}</TableCell>
                  <TableCell align="left">{datas.RMP}</TableCell>
                  <TableCell align="left">{datas.threadinch}</TableCell>
                  <TableCell align="left">{datas.threadConsumptionFactor}</TableCell>
                  <TableCell align="center">
                    {datas.Active === 'Y' ? (
                      <Chip icon={<CheckCircleOutlineIcon />} color="success" size="small" label="Active" />
                    ) : (
                      <Chip icon={<HighlightOffIcon />} color="error" size="small" label="InActive" />
                    )}
                  </TableCell>

                  <TableCell align="center" sx={{ padding: '0' }}>
                    <IconButton aria-label="Edit" onClick={() => handleEdit(datas)}>
                      <EditIcon color="primary" />
                    </IconButton>
                    <IconButton aria-label="Delete" onClick={() => handleDelete(datas.Machine_Id)}>
                      <DeleteForeverIcon color="error" />
                    </IconButton>
                  </TableCell>
                </TableRow>
              ))}

              {emptyRows > 0 && (
                <TableRow style={{ height: 53 * emptyRows }}>
                  <TableCell colSpan={9} />
                </TableRow>
              )}
            </TableBody>
          </Table>
        </TableContainer>

        {/* pagination */}
        <TablePagination
          rowsPerPageOptions={[5, 10, 25]}
          component="div"
          count={totalRows}
          rowsPerPage={rowsPerPage}
          page={currentPage} // Use the calculated currentPage value
          onPageChange={(event, newPage) => setPage(newPage)}
          onRowsPerPageChange={(event) => {
            setRowsPerPage(parseInt(event.target.value, 10));
            setPage(0); // Reset the page when rowsPerPage changes
          }}
          mt={2}
        />
      </Container>

      <Grid m={2}>
        {/* add new popup form dialog box */}
        <Dialog fullScreen={fullScreen} open={open} onClose={handleClose} fullWidth>
          <Container component={Paper} elevation={2} sx={{ py: 2 }}>
            <form onSubmit={handleSubmit} noValidate>
              <Stack direction={'row'} justifyContent={'space-between'} alignItems={'center'} mr={1}>
                <Typography variant="h5" textAlign={'left'} pl={1} fontWeight={600} color="primary">
                  {operation} Machine
                </Typography>
                <IconButton onClick={handleClose}>
                  <CloseIcon />
                </IconButton>
              </Stack>
              <Stack direction={'column'} spacing={2} p={1}>
                <Grid container spacing={2} rowSpacing={2} columnSpacing={2}>
                  <Grid item xs={12}>
                    {' '}
                    <TextField
                      type="text"
                      variant="outlined"
                      color="primary"
                      label="Machine Type"
                      name="MachineType"
                      value={MachineType === null ? '' : MachineType}
                      onBlur={handleBlur}
                      onChange={handleInputChange}
                      fullWidth
                      size="small"
                      required
                      error={errors.MachineType}
                      helperText={helperTexts.MachineType}
                      className={isFormSubmitted && errors.MachineType ? 'shake-helper-text' : ''}
                    />
                  </Grid>
                  <Grid item xs={12}>
                    <TextField
                      type="text"
                      variant="outlined"
                      color="primary"
                      label="Machine Name"
                      name="MachineName"
                      value={MachineName === null ? '' : MachineName}
                      onBlur={handleBlur}
                      onChange={handleInputChange}
                      fullWidth
                      required
                      size="small"
                      error={errors.MachineName}
                      helperText={helperTexts.MachineName}
                      className={isFormSubmitted && errors.MachineName ? 'shake-helper-text' : ''}
                    />
                  </Grid>
                  <Grid item xs={12} md={4}>
                    <TextField
                      type="text"
                      variant="outlined"
                      color="primary"
                      label="SPI"
                      name="StitchperInch"
                      value={StitchperInch === null ? '' : StitchperInch}
                      onBlur={handleBlur}
                      onChange={handleInputChange}
                      fullWidth
                      size="small"
                      error={errors.StitchperInch}
                      helperText={helperTexts.StitchperInch}
                      className={isFormSubmitted && errors.StitchperInch ? 'shake-helper-text' : ''}

                    />
                  </Grid>
                  <Grid item xs={12} md={4}>
                    <TextField
                      type="text"
                      variant="outlined"
                      color="primary"
                      label="RPM"
                      name="RMP"
                      value={RMP === null ? '' : RMP}
                      onBlur={handleBlur}
                      onChange={handleInputChange}
                      fullWidth
                      size="small"
                      error={errors.RMP}
                      helperText={helperTexts.RMP}
                      className={isFormSubmitted && errors.RMP ? 'shake-helper-text' : ''}
                    />
                  </Grid>
                  <Grid item xs={12} md={4}>
                    <TextField
                      type="text"
                      variant="outlined"
                      color="primary"
                      label="TPI"
                      name="threadinch"
                      value={Inch}
                      onBlur={handleBlur}
                      onChange={handleInputChange}
                      fullWidth
                      size="small"
                      error={errors.threadinch}
                      helperText={helperTexts.threadinch}
                      className={isFormSubmitted && errors.threadinch ? 'shake-helper-text' : ''}
                    />
                  </Grid>
                  {/* Thread Consumption Factor TCF  */}
                  <Grid item xs={12} md={4}>
                    <TextField
                      type="text"
                      variant="outlined"
                      color="primary"
                      label="TCF"
                      name="threadConsumptionFactor"
                      value={tcf}
                      onBlur={handleBlur}
                      onChange={handleInputChange}
                      fullWidth
                      size="small"
                      error={errors.threadConsumptionFactor}
                      helperText={helperTexts.threadConsumptionFactor}
                      className={isFormSubmitted && errors.threadConsumptionFactor ? 'shake-helper-text' : ''}
                    />
                  </Grid>
                  <Grid item xs={12} md={6}>
                    <FormControl size="small" fullWidth component="fieldset">
                      <Stack direction={'row'} justifyContent={'flex-start'} algnItems={'center'} spacing={2}>
                        <FormLabel component="legend" sx={{ pt: 1 }}>
                          Active
                        </FormLabel>
                        <RadioGroup row value={Active} name="Active" onChange={handleInputChange}>
                          <FormControlLabel value="Y" control={<Radio />} label="Yes" />
                          <FormControlLabel value="N" control={<Radio />} label="No" />
                        </RadioGroup>
                      </Stack>
                      {errors.Active && (
                        <Typography
                          variant="caption"
                          color="error"
                          className={isFormSubmitted && errors.Active ? 'shake-helper-text' : ''}
                        >
                          {errors.Active && helperTexts.Active}
                        </Typography>
                      )}
                    </FormControl>
                  </Grid>
                </Grid>

                <Button type="submit" variant="contained" color="primary" size="small" sx={{ boxShadow: 1 }} fullWidth>
                  Save
                </Button>
              </Stack>
            </form>
          </Container>
        </Dialog>
      </Grid>

      {/* confirmation dialog */}
      <Dialog
        open={openDelete}
        onClose={handleCloseDelete}
        aria-labelledby="responsive-dialog-title"
        fullScreen={fullScreen}
        fullWidth
        maxWidth="xs"
      >
        <DialogTitle id="responsive-dialog-title">Are you sure you want to delete?</DialogTitle>
        <DialogActions>
          <Button variant="contained" autoFocus onClick={handleCloseDelete} color="primary">
            Cancel
          </Button>
          <Button variant="contained" onClick={() => handleDeleteConfirmed(IdToDelete)} color="error" autoFocus>
            Delete
          </Button>
        </DialogActions>
      </Dialog>

      {/* loader popup dialog box */}
      <Dialog
        open={openLoader}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
        fullWidth
      >
        <LinearProgress />
      </Dialog>
    </>
  );
};

export default MachineMst;
